export const BASE_API_URL = 'https://ps9et7hsp3.execute-api.eu-central-1.amazonaws.com/frontend';

// Token mentése
export const saveToken = (token: string): void => {
  localStorage.setItem('authToken', token);
};

// Token lekérése
export const getToken = (): string | null => {
  return localStorage.getItem('authToken');
};

// Bejelentkezett állapot ellenőrzése
export const isLoggedIn = (): boolean => {
  return getToken() !== null;
};

// Általános API hívás wrapper
export const fetchApi = async (operation: string, payload: Record<string, any> = {}): Promise<any> => {
  const token = getToken();

  // Minden híváshoz automatikusan hozzáadja a token-t (ha van)
  if (token) {
    payload.jwt_token = token;
  }

  console.log(`API hívás: ${operation}`, payload);

  const response = await fetch(BASE_API_URL, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      operation,
      payload
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error(`API hiba (${operation}):`, errorText);
    throw new Error(errorText || 'API request failed');
  }

  return response.json();
};
